module.exports = __webpack_public_path__ + "static/media/Solution_Mobile_Bg@2x.08cf7312.png";